function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "159.1,166 176.6,109.9 140.1,81.9 45.8,174.4 147.2,174.4 159.1,166.3 \t\t\t\t"
}), React.createElement("polygon", {
  className: "st0",
  points: "276.1,81.9 239.6,109.9 257.2,166.3 269.1,174.4 370.5,174.4 \t\t\t\t"
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "259.1,50 220.6,49.9 208.1,13 195.6,49.9 157.2,50 187.9,73.7 176.6,110 208.1,88.4 239.6,110  228.3,73.7 \t\t\t\t"
}), React.createElement("polygon", {
  className: "st0",
  points: "208.3,132.8 208.1,132.8 147.2,174.4 269.1,174.4 \t\t\t\t"
}))), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M385.7,96v-8.2h13.9V69.9l10.3-4.5v22.3h17.5V96h-17.5v55.5c0,11.5,1.2,14.2,9.4,14.2 c3.4,0,5.8-0.2,8.1-0.5v8.9c-3.1,0.3-6.5,0.5-9.8,0.5c-13.9,0-18-6.2-18-16.8V96H385.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M449.2,133.2v6.7c0,12,3.3,27.9,19.5,27.9c12.9,0,19.2-8.2,19-19.9h10.8c-1.2,20.9-12.5,28.1-29.8,28.1 c-14.9,0-29.8-6-29.8-32.2v-21.3c0-25,10.5-36.5,29.8-36.5c29.8,0,29.8,21.4,29.8,47.1H449.2z M488.2,124.9 c0-19.2-3.1-30.7-19.5-30.7c-16.5,0-19.5,11.5-19.5,30.7H488.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M555.8,112.6c0.5-10.8-3.4-18.3-15.3-18.3c-6.3,0-11.7,3.6-13.9,9.9c-1.4,3.9-2.4,15.8-2.4,27.3 c0,15.6,0,36.3,15.9,36.3c13.5,0,15.3-8.6,15.8-19h10.3c0.9,23.3-15.6,27.3-23.6,27.3c-29.3,0-29.3-23.1-29.3-44.6 c0-8.6,0.3-22.1,2.6-28.6c4.5-12.3,14.2-16.8,26.1-16.8c14.9,0,25,8.4,24.2,26.6H555.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M583.9,174.3V50.5h10.3v47.8h0.3c5-7.2,11.7-12.3,20.9-12.3c21.4,0,23.7,15.9,23.7,27.3v61h-10.3v-60.5 c0-10.1-3.9-19.5-15.9-19.5c-9.3,0-18.7,6.3-18.7,25.7v54.3H583.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M683,176c-18.7,0-26.1-9.1-25.9-27.4h10.5c0,11.8,2.7,19.7,15.9,19.7c9.9,0,14.7-5.7,14.7-15.3 c0-22.6-38.9-16.8-38.9-45.4c0-15.9,11-21.6,26.1-21.6c17.1,0,22.6,11.8,22.6,25h-10.1c-0.5-11-3.4-16.8-15.1-16.8 c-7.4,0-13.2,4.8-13.2,12.5c0,21.6,38.9,15.8,38.9,44.7C708.5,167.8,699.1,176,683,176z"
}), React.createElement("path", {
  className: "st0",
  d: "M719,96v-8.2h13.9V69.9l10.3-4.5v22.3h17.5V96h-17.5v55.5c0,11.5,1.2,14.2,9.4,14.2c3.4,0,5.8-0.2,8.1-0.5 v8.9c-3.1,0.3-6.5,0.5-9.8,0.5c-13.9,0-18-6.2-18-16.8V96H719z"
}), React.createElement("path", {
  className: "st0",
  d: "M819.1,163.7h-0.3c-5.5,8.2-13.9,12.3-24.5,12.3c-15.4,0-23.8-10.5-23.8-25.5c0-30.3,30.5-27.3,48-28.6 v-7.2c0-12.7-3.8-20.4-17.5-20.4c-9.4,0-17,4.6-17,14.9h-11c0.9-16.6,13.7-23.1,28.8-23.1c8.7,0,26.9,0.9,26.9,23v43.5 c0,6.2,0,11.7,1,21.8h-10.6V163.7z M818.4,130.1c-14.7,0.5-37-1.2-37,19.9c0,9.8,5,17.8,15.6,17.8c11.8,0,21.4-10.6,21.4-21.9 V130.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M861.4,99.4h0.3c4.3-8.2,13.4-13.4,23.8-13.4v10.5c-14.6-1.2-24.2,7.5-24.2,22.1v55.7h-10.3V87.7h10.3V99.4 z"
}), React.createElement("path", {
  className: "st0",
  d: "M920.2,176c-18.7,0-26.1-9.1-25.9-27.4h10.4c0,11.8,2.7,19.7,15.9,19.7c9.9,0,14.7-5.7,14.7-15.3 c0-22.6-38.9-16.8-38.9-45.4c0-15.9,11-21.6,26.1-21.6c17.1,0,22.6,11.8,22.6,25h-10.1c-0.5-11-3.4-16.8-15.1-16.8 c-7.4,0-13.2,4.8-13.2,12.5c0,21.6,38.9,15.8,38.9,44.7C945.8,167.8,936.4,176,920.2,176z"
})))), React.createElement("text", {
  transform: "matrix(1 0 0 1 945.7818 86.0284)",
  className: "st0 st1 st2"
}, "\xAE"));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 991.6 189",
    style: {
      "enableBackground": "new 0 0 991.6 189"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/techstars.60a00a99.svg";
export { SvgComponent as ReactComponent };